










































import DictMixin from '@/mixins/dict-mixin';
import MenuMixin from '@/mixins/menu-mixin';
import CronjobServices from '@/services/cronjob';
import { mixins } from 'vue-class-component';
import { Component, Prop, Watch } from 'vue-property-decorator';
import JobDetail from './job-record-detail.vue';
@Component({
  components: { JobDetail }
})
export default class JobList extends mixins(DictMixin, MenuMixin) {
  @Prop() name!: any;
  @Prop() type!: any;
  @Prop() list!: any;

  jobSrv = new CronjobServices();
  date: any = '';

  get TYPE() {
    return this.type.toUpperCase();
  }

  visible = false;
  visible2 = false;

  pagination = { showTotal: () => `共 ${this.list.length} 条` };
  columns = [
    { title: '作业编号', dataIndex: 'jobCode' },
    { title: this.name, dataIndex: 'jobNameEx' },
    { title: '作业处理数据日期', dataIndex: 'dataDate' },
    { title: '运行时长', dataIndex: 'costTime', customRender: (text: string) => `${text ? text + 'ms' : ''}` },
    {
      title: '任务处理类型',
      dataIndex: 'jobRunType',
      scopedSlots: {
        customRender: 'jobRunType'
      }
    },
    {
      title: '处理状态',
      dataIndex: 'handleStatus',
      scopedSlots: {
        customRender: 'handleStatus'
      }
    },
    { title: '作业执行人', dataIndex: 'createUser' },
    {
      title: '操作',
      dataIndex: 'action',
      width: 140,
      scopedSlots: {
        customRender: 'action'
      }
    }
  ];

  detail: any = {};
  async getDetail(record: any) {
    this.detail = record;
    this.visible = true;
  }

  reRun(record: any) {
    this.submitBatch([
      {
        id: record.jobId,
        jobGroupName: record.jobGroupName,
        type: 2,
        handleDataDate: record.dataDate
      }
    ]);
  }

  selectedRows: any[] = [];
  selectedRowKeys: any[] = [];
  onSelectChange(keys: any, rows: any) {
    this.selectedRowKeys = keys;
    this.selectedRows = rows;
  }
  handleBatch(e: any) {
    if (e.key === 'reRunAll') {
      if (this.selectedRows.length === 0) {
        this.$message.error('请选中至少一条数据');
        return false;
      }
      let params: { id: number; jobGroupName: string; type: 2; handleDataDate: string }[] = this.selectedRows.map((record: any) => ({
        id: record.jobId,
        jobGroupName: record.jobGroupName,
        type: 2,
        handleDataDate: record.dataDate
      }));
      this.submitBatch(params);
    }
  }

  async submitBatch(params: { id: number; jobGroupName: string; type: 2; handleDataDate: string }[]) {
    this.$confirm({
      title: '重跑确认',
      content: '是否确认操作！',
      okText: '确认',
      cancelText: '取消',
      onOk: async () => {
        let res = await this.jobSrv.run(params);
        if (res) {
          this.$message.success('操作成功');
          this.selectedRowKeys = [];
          this.$emit('reload');
        }
      }
    });
  }

  @Watch('$route')
  onRouteChange() {
    /\/jobs\/record/.test(this.$route.path) && this.$emit('reload');
  }

  bodyStyle = { backgroundColor: '#EEE' };
}
